import { render } from "./NaechsteSchritte.vue?vue&type=template&id=370bcab4"
import script from "./NaechsteSchritte.vue?vue&type=script&lang=js"
export * from "./NaechsteSchritte.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__